module.exports = __webpack_public_path__ + "img/Hospital1.9a08f2b1.jpg";